export interface Review {
  initials: string
  name: string
  role: string
  text: string
}

export const reviews: Review[] = [
  {
    initials: 'DR',
    name: 'Daniel R.',
    role: 'Boxing Coach',
    text: 'I used to spend way too much time planning every session from scratch. Now I can open the material, choose what I need, and have a structured class ready in minutes. It has made my weekly planning much easier.',
  },
  {
    initials: 'MT',
    name: 'Michael T.',
    role: 'Boxing Gym Owner',
    text: 'The biggest difference for me is the structure. My sessions feel much more organized, and I always know what progression to use next. It gives me a clear direction for each class instead of improvising everything.',
  },
  {
    initials: 'CA',
    name: 'Chris A.',
    role: 'Boxing Instructor',
    text: 'I was looking for more variety because I felt like I was repeating the same drills too often. The drills, progressions, and correction ideas have given me a lot more options to use with my athletes.',
  },
]
